var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgColorRight = function SvgColorRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 40,
    height: 37,
    viewBox: "0 0 3.23 2.98",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 1.09c0 .16.13.19.26.18.13-.02.21-.04.23-.18.03-.15-.06-.27-.2-.31-.24-.07-.29.12-.29.31z",
    fill: "#005bbc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23.58c-.11.04-.19.11-.2.25-.02.22.3.4.51.08.07-.09.01-.28-.14-.32-.06-.01-.11-.03-.17-.01z",
    fill: "#ffd600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.57 1.47c0 .23.59.38.49-.15-.04-.24-.48-.23-.49.15z",
    fill: "#ff5252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.95 1.94c-.12.14.03.34.21.38.11.03.18-.01.22-.14.04-.11.02-.26-.12-.31-.12-.04-.22-.03-.31.07z",
    fill: "#6cd48d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 2.31a.196.196 0 0 1-.05-.28c.06-.09.19-.11.28-.05.03.02.06.06.1.1l.01.02c.05.06.12.14.18.19.14.1.13.2.05.31-.03.04-.05.05-.08.08-.02 0-.03.02-.04.02-.03.04-.1.11-.16.17l-.07.06c-.08.07-.21.07-.28-.01-.08-.08-.08-.21 0-.28l.07-.07c.04-.03.08-.08.11-.11-.03-.04-.07-.07-.09-.11l-.01-.01c-.02-.02-.01-.02-.02-.03zM.64 2.24c.19.21.41.32.61.34.1.01.2-.01.28-.04a.39.39 0 0 0 .17-.14c.04-.08.06-.19.02-.33-.03-.14-.06-.28-.01-.41.06-.16.19-.26.47-.26.12.01.21-.01.27-.05.05-.03.08-.09.09-.18.02-.15-.08-.3-.23-.44-.19-.16-.46-.28-.73-.32C1.24.37.98.46.79.63a.96.96 0 0 0-.25.32c-.06.13-.11.27-.12.41-.05.32.02.65.22.88zm.57.74C.92 2.95.6 2.8.33 2.5c-.27-.31-.37-.76-.31-1.19.02-.19.07-.37.16-.54C.26.6.38.45.52.32c.28-.23.65-.37 1.11-.3.35.04.7.2.94.41.26.22.41.5.37.78-.02.22-.12.37-.26.47-.14.09-.31.13-.51.13-.06 0-.08-.02-.08-.01-.01.02 0 .09.02.17.07.25.03.46-.07.63-.08.14-.2.24-.35.31-.14.06-.31.09-.48.07z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

export default SvgColorRight;